<template>
  <div id="app">
    <div class="reflect">
      <div class="header">
        <span>{{ $t("column.Withdrawal_to")}}</span>
        <div class="head_right" @click="reflectW">
          <p>{{ withdrawallist.account }}
            <van-icon name="arrow" />
          </p>
        </div>
      </div>
      <van-popup v-model="show" position="bottom">
        <div class="reflect_W">
          <div class="reflect_W_L">
            <span>{{ withdrawallist.alipay_name }}</span>
          </div>
          <div class="reflect_W_r" @click="setData($event)">
            {{ withdrawallist.alipay_account }}
          </div>
        </div>
      </van-popup>
      <div class="withdrawal">
        <div class="withdrawal_M">
          <span>{{ $t('column.Total_balance') }}：</span>
          <p>{{ withdrawallist.invitation_coin }}{{ withdrawallist.ticket_name }}</p>
        </div>
        <div class="withdrawal_M">
          <span>{{ $t('column.Withdrawal_quantity') }}：</span>
          <input type="number" v-model="number" class="silver_coin_to_input" :placeholder="$t('column.Please_enter_withdrawal_quantity')" @input="SaveDeduction" style="width: 65%;border-left: 0;border-top: 0;border-right: 0;border-bottom: 1px solid #dddddd;height: 2rem;font-size: 1rem;"/>
        </div>
        <div class="withdrawal_M">
          <span>{{ $t('column.Amount_received') }}：</span>
          <p v-if="invitation_coin">{{ invitation_coin }}{{ $t("other.yuan")}}</p>
        </div>
        <div class="reflectBtn" @click="withdrawal_btn">{{ $t("column.Immediate_withdrawal") }}</div>
      </div>
    </div>
    <div class="reflectTips">
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  export default {
    data() {
      return {
        list: [],
        danDisplay: 0, //默认选择第一个money
        show: false, //判断弹出层是否显示
        wechatNumber: "" ,//获取点击的微信号
        withdrawallist:[], //接收邀请提现数据
        content:'',
        number: undefined,
        invitation_coin: undefined
      }
    },
    methods: {
      //动态class切换样式
      withdrawalBtn(index) {
        this.danDisplay = index;
      },
      SaveDeduction() {
        // 改变扣费值
        this.invitation_coin = Math.floor(this.withdrawallist.ratio * this.number * 100) / 100
      },
      //点击提现到弹出层
      reflectW() {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        this.$router.push({
          path: "/banding_bank",
          query:{uid:uid, token: token}
        })
        this.show = true;  //图案储层是否显示
      },
      setData(e) {
        this.show = false;
        e = event.target.innerHTML;
        this.wechatNumber = e;
      },
      //邀请提现接口
      withdrawal(){
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath +
          "?ctl=invite_vue&act=withdrawal&token="+token)
          .then(res => {
            console.log( res)
            if (res.data.status) {
              this.withdrawallist = res.data.data
            }
          }).catch((res) => {
          console.log("请求失败");
        })
      },
      get_withdrawal_rules(){
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath +
          "?ctl=invite_vue&act=get_withdrawal_rules")
          .then(res => {
            console.log( res)
            if (res.data.status) {
              this.list = res.data.data.list
              this.content = res.data.data.content
            }
          }).catch((res) => {
          console.log("请求失败");
        })
      },
      withdrawal_btn(){
        // 提现
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=add_withdrawal", {
          params: {
            user_id: uid,
            token: token,
            number: this.number
          }
        }).then(res => {
          console.log(res.data)
          Toast(res.data.error)
          if (res.data.status === 1) {
            setTimeout(()=>{
              this.withdrawal(); //邀请提现接口
              this.number = 0
              //  this.get_withdrawal_rules(); //邀请提现接口
            }, 1000);
          }
        })
      }
    },
    created: function() {
      document.title = this.$t("btn.Withdrawal");
      this.withdrawal(); //邀请提现接口
      //  this.get_withdrawal_rules(); //邀请提现接口
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/reflect.vue